// src/components/empresas/EmpresasPage/EmpresasPresentation.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Typography,
  Box,
  Alert
} from '@mui/material';
import {
  VpnKey as VpnKeyIcon,
  Check as CheckIcon,
  ReceiptLong as ReceiptLongIcon,
} from '@mui/icons-material';

import {
  DataTable,
  EmptyState,
  CardContainer
} from '../../shared';

/**
 * Componente de presentación para la lista de empresas (organizaciones UAU).
 * Solo lectura: las organizaciones se gestionan desde UAU.
 */
const EmpresasPresentation = ({
  empresas,
  empresaActiva,
  columns,
  onSelectEmpresa,
  onNavigateToCertificados,
  onNavigateToConfigTributaria,
}) => {
  const tableActions = [
    {
      icon: <VpnKeyIcon fontSize="small" />,
      tooltip: 'Gestionar certificados',
      onClick: onNavigateToCertificados
    },
    {
      icon: <ReceiptLongIcon fontSize="small" />,
      tooltip: 'Configuración tributaria DTE',
      onClick: onNavigateToConfigTributaria
    },
    {
      icon: <CheckIcon fontSize="small" color="primary" />,
      tooltip: 'Seleccionar como empresa activa',
      onClick: onSelectEmpresa,
      disabled: (row) => empresaActiva?.id === row.id
    }
  ];

  return (
    <Container maxWidth="lg">
      <CardContainer
        title="Organizaciones"
        subheader="Seleccione la empresa activa para trabajar y gestione sus certificados digitales"
      >
        <Alert severity="info" sx={{ mb: 2 }}>
          Las organizaciones se administran desde el sistema UAU. Aquí puede seleccionar la empresa activa y gestionar certificados digitales.
        </Alert>

        {empresas && empresas.length > 0 ? (
          <DataTable
            columns={columns}
            data={empresas}
            actions={tableActions}
            pagination={true}
            stickyHeader={true}
          />
        ) : (
          <EmptyState
            title="No hay organizaciones disponibles"
            message="No se encontraron organizaciones asignadas a su usuario. Contacte al administrador del sistema UAU."
            usePaper={true}
          />
        )}
      </CardContainer>
    </Container>
  );
};

EmpresasPresentation.propTypes = {
  empresas: PropTypes.array,
  empresaActiva: PropTypes.object,
  columns: PropTypes.array.isRequired,
  onSelectEmpresa: PropTypes.func.isRequired,
  onNavigateToCertificados: PropTypes.func.isRequired,
  onNavigateToConfigTributaria: PropTypes.func.isRequired,
};

export default EmpresasPresentation;
